import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function FailedAttemptsSection() {
  const attempts = [{
    title: 'Suplementos de colágeno o glucosamina',
    desc: 'No funcionan si tu célula está bloqueada por exceso de sodio industrial.'
  }, {
    title: "Beber 'mucha agua sola'",
    desc: 'A veces te deshidrata más porque diluye los minerales esenciales que mantienen tus músculos relajados.'
  }, {
    title: 'Dietas extremas de jugos verdes',
    desc: 'Disparan el cortisol, la hormona que irónicamente te hace retener más líquido y grasa abdominal.'
  }, {
    title: 'Antiinflamatorios de farmacia',
    desc: "Irritan tu mucosa intestinal, creando un ciclo de 'intestino colador' que aumenta la inflamación sistémica."
  }];
  return <section className="py-20 bg-forest text-white" data-id="element-55">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-56">
        <FadeIn data-id="element-57">
          <div className="text-center mb-16" data-id="element-58">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-cream" data-id="element-59">
              Por qué lo que has intentado NO funciona
            </h2>
            <p className="text-emerald-light text-lg max-w-2xl mx-auto" data-id="element-60">
              La industria de la salud te ha vendido soluciones a medias que
              ignoran la raíz del problema.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-61">
          {attempts.map((attempt, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-62">
              <div className="bg-forest-light/30 border border-emerald/20 p-6 rounded-2xl flex items-start gap-4 h-full hover:bg-forest-light/40 transition-colors" data-id="element-63">
                <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-64" />
                <div data-id="element-65">
                  <h4 className="font-bold text-lg mb-2 text-cream" data-id="element-66">
                    {attempt.title}
                  </h4>
                  <p className="text-gray-300 text-sm leading-relaxed" data-id="element-67">
                    {attempt.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}